import {MuseOn} from "./MuseOn";

export class Category extends MuseOn {
    _id: string;
    name: string;
    order: number;
    preferred: boolean;
    database_id: string;

    constructor (data) {
        super();

        this._id = data._id;
        this.name = data.name;
        this.order = data.order;
        this.preferred = data.preferred;
        this.database_id = data.database_id;
    }

    getObj(removeNull: boolean = false) {
        const result =  {
            name: this.name,
            order: this.order,
            database: this.database_id,
            preferred: this.preferred,
        };

        return removeNull
            ? this.removeNull(result)
            : result
        ;
    }
}